import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

const ProcessingStep = ({ formData, setFormData }) => {
  const updateProcessingVolumes = (field, value) => {
    setFormData(prev => ({
      ...prev,
      processing: {
        ...prev.processing,
        volumes: { ...prev.processing?.volumes, [field]: value }
      }
    }));
  };

  const updateProcessingSales = (field, value) => {
    setFormData(prev => ({
      ...prev,
      processing: {
        ...prev.processing,
        sales: { ...prev.processing?.sales, [field]: value }
      }
    }));
  };

  const updateProcessing = (field, value) => {
    setFormData(prev => ({
      ...prev,
      processing: { ...prev.processing, [field]: value }
    }));
  };

  return (
    <div className="space-y-8">
      <div className="bg-slate-800 p-6 rounded-lg">
        <h3 className="text-xl font-semibold text-slate-100 mb-6">Processing Information</h3>
        
        <div className="space-y-6">
          <div>
            <Label className="text-slate-200 text-lg mb-4 block">Transaction Volumes</Label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <Label className="text-slate-200">Monthly Transaction Amount *</Label>
                <Input
                  type="number"
                  value={formData.processing?.volumes?.monthlyTransactionAmount || ''}
                  onChange={(e) => updateProcessingVolumes('monthlyTransactionAmount', e.target.value)}
                  className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
                  placeholder="$"
                  data-testid="monthly-transaction-amount"
                />
              </div>
              
              <div>
                <Label className="text-slate-200">Average Transaction Amount *</Label>
                <Input
                  type="number"
                  value={formData.processing?.volumes?.avgTransactionAmount || ''}
                  onChange={(e) => updateProcessingVolumes('avgTransactionAmount', e.target.value)}
                  className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
                  placeholder="$"
                  data-testid="avg-transaction-amount"
                />
              </div>
              
              <div>
                <Label className="text-slate-200">Max Transaction Amount *</Label>
                <Input
                  type="number"
                  value={formData.processing?.volumes?.maxTransactionAmount || ''}
                  onChange={(e) => updateProcessingVolumes('maxTransactionAmount', e.target.value)}
                  className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
                  placeholder="$"
                  data-testid="max-transaction-amount"
                />
              </div>
            </div>
          </div>

          <div>
            <Label className="text-slate-200 text-lg mb-4 block">Sales Breakdown (must total 100%)</Label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div>
                <Label className="text-slate-200">Swiped (Card Present) %</Label>
                <Input
                  type="number"
                  value={formData.processing?.sales?.swiped || ''}
                  onChange={(e) => updateProcessingSales('swiped', e.target.value)}
                  className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
                  min="0"
                  max="100"
                  data-testid="sales-swiped"
                />
              </div>
              
              <div>
                <Label className="text-slate-200">Mail/Phone Order %</Label>
                <Input
                  type="number"
                  value={formData.processing?.sales?.mail || ''}
                  onChange={(e) => updateProcessingSales('mail', e.target.value)}
                  className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
                  min="0"
                  max="100"
                  data-testid="sales-mail"
                />
              </div>
              
              <div>
                <Label className="text-slate-200">Internet/eCommerce %</Label>
                <Input
                  type="number"
                  value={formData.processing?.sales?.internet || ''}
                  onChange={(e) => updateProcessingSales('internet', e.target.value)}
                  className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
                  min="0"
                  max="100"
                  data-testid="sales-internet"
                />
              </div>
            </div>
          </div>

          <div>
            <Label className="text-slate-200">Equipment Used *</Label>
            <Input
              value={formData.processing?.equipmentUsed || ''}
              onChange={(e) => updateProcessing('equipmentUsed', e.target.value)}
              className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
              placeholder="List equipment and/or software used to process cards (point-of-sale, terminal, payment gateway, etc.)"
              data-testid="equipment-used"
            />
          </div>

          <div>
            <Label className="text-slate-200">Refund Policy *</Label>
            <Textarea
              value={formData.processing?.refundPolicy || ''}
              onChange={(e) => updateProcessing('refundPolicy', e.target.value)}
              className="mt-2 bg-slate-900 border-slate-700 text-slate-100"
              placeholder="Describe your refund and return policy"
              rows={4}
              data-testid="refund-policy"
            />
          </div>

          <div>
            <Label className="text-slate-200 mb-3 block">Do you currently accept credit/debit cards?</Label>
            <div className="space-y-2">
              <div className="flex items-center">
                <input type="radio" id="processing-yes" name="currentlyProcessing" className="mr-2" />
                <Label htmlFor="processing-yes" className="text-slate-300 cursor-pointer">Yes</Label>
              </div>
              <div className="flex items-center">
                <input type="radio" id="processing-no" name="currentlyProcessing" className="mr-2" defaultChecked />
                <Label htmlFor="processing-no" className="text-slate-300 cursor-pointer">No</Label>
              </div>
            </div>
          </div>

          <div>
            <Label className="text-slate-200 mb-3 block">Has your business or any principal ever been terminated from accepting bank cards?</Label>
            <div className="space-y-2">
              <div className="flex items-center">
                <input type="radio" id="terminated-yes" name="terminated" className="mr-2" />
                <Label htmlFor="terminated-yes" className="text-slate-300 cursor-pointer">Yes</Label>
              </div>
              <div className="flex items-center">
                <input type="radio" id="terminated-no" name="terminated" className="mr-2" defaultChecked />
                <Label htmlFor="terminated-no" className="text-slate-300 cursor-pointer">No</Label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingStep;
